import React, { Component } from 'react';
//import { theme } from 'constants'
import { Scene, View, Text, Button, TextArea, isWeb } from 'core';
import { theme, css, isMVP } from 'constants';
import { lang } from 'lang';
import { version } from '../../../../package.json';

const styles = css({
  main: {
    paddingVertical: isWeb ? 80 : 40,
    paddingHorizontal: 40,
    alignSelf: isWeb ? 'center' : 'auto'
  },
  supp_msg_header: {
    fontSize: theme.font_xl,
    marginVertical: 10
  },
  supp_msg: {
    fontSize: theme.font_lg,
    marginVertical: 1
  },
  msg: {
    flex: 1,
    borderRadius: 20
  }
});

const field = {
  borderColor: theme.primary_color,
  paddingTop: 20
};
class Account extends Component {
  render() {
    const { user } = this.props.support;
    return (
      <Scene avoidKeyboard style={styles.main}>
        <Text style={styles.supp_msg_header}>{lang.HEY + ' ' + user.name} </Text>
        <Text style={styles.supp_msg}>{lang.SUPPORT_MESSAGE}</Text>
        {isMVP ? null : (
          <View
            style={{
              marginVertical: 40
            }}
          >
            <TextArea
              onChangeText={description => this.setState({ description })}
              style={field}
              min_row={isWeb ? 10 : 5}
              max_row={10}
              font_size={theme.font_lg}
              placeholder={lang.HELP_PLACEHOLDER}
            />
            <Button title={lang.ASK_HELP} style={{ width: 150, marginTop: 20, alignSelf: 'flex-end' }} />
          </View>
        )}
        <Text style={{ color: theme.gray_color_alpha(0.4), marginTop: 10, alignSelf: 'center' }}>fosol v{version}</Text>
      </Scene>
    );
  }
}
export default Account;



// WEBPACK FOOTER //
// ./src/components/middle/settings/support.js